import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { env } from '../../config/env';

import {
    downloadSettlementCsvUrl,
    paymentsUrl,
    payoutsUrl,
    settlementsAnalyticsUrl,
    singlePayoutsUrl,
    unsettledSettlementsUrl
} from '../../shared/helpers/endPoints';
import {
    DOWNLOAD_SETTLEMENT_CSV,
    GET_ALL_PAYOUTS,
    GET_SETLLEMENTS_ANALYTICS,
    GET_SETTLEMENT_TRANSACTION,
    GET_SINGLE_PAYOUTS,
    GET_UNSETTLED_SETTLEMENTS
} from './actionTypes';
import { fetchJSON } from '../../shared/helpers/apiCalls';

import {
    getSettlementsAnalyticsSuccess,
    getSettlementsCsvSuccess,
    setAllPayouts,
    setSettlementsTransactionSuccess,
    setSinglePayouts
} from './action';
import { getStoreLocal } from '../../shared/helpers/utils';
import { authService } from '../../modules/users/services/dependency.injection';
import { toast } from 'react-toastify';

function* callGetSinglePayouts({ payload: payoutId }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: singlePayoutsUrl(modeType),
            params: { id: payoutId, tag: env.REACT_APP_SPAY_SETTLEMENT_TAG || 'MCH_settlement_admin' },

            headers: {
                Authorization: `Bearer ${access_token}`,
                'api-key': env.REACT_APP_SPAY_SETTLEMENT_CD
            }
        };

        const response = yield call(fetchJSON, options);

        yield put(setSinglePayouts(response.data));
    } catch (error) { }
}

function* callGetAllPayouts({ payload: values }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: payoutsUrl(modeType),
            params: { ...values, tag: env.REACT_APP_SPAY_SETTLEMENT_TAG || 'MCH_settlement_admin' },
            headers: {
                Authorization: `Bearer ${access_token}`,
                'api-key': env.REACT_APP_SPAY_SETTLEMENT_CD
            }
        };

        console.log('DEBUG: callGetAllPayouts options', options);

        const response = yield call(fetchJSON, options);

        yield put(setAllPayouts(response.data));
    } catch (error) { }
}

function* callGetUnsettledPayout({ payload: values }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: unsettledSettlementsUrl(modeType),
            params: { ...values },
            headers: {
                Authorization: `Bearer ${access_token}`
            }
        };

        const response = yield call(fetchJSON, options);

        yield put(setAllPayouts({ settlements: response.data }));
    } catch (error) {
        const errorMessage = error?.data?.error?.message ? error.data?.error?.message : 'Something went wrong';
        toast.error(errorMessage);
    }
}

function* callGetTransactionForSettlement({ payload: values }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');
    try {
        const options = {
            method: 'GET',
            url: paymentsUrl(modeType),
            params: { ...values },
            headers: {
                Authorization: `Bearer ${access_token}`
            }
        };

        const response = yield call(fetchJSON, options);

        yield put(setSettlementsTransactionSuccess(response.data));
    } catch (error) {
        const errorMessage = error?.data?.error?.message ? error.data?.error?.message : 'Something went wrong';
        toast.error(errorMessage);
    }
}

function* callGetSettlementAnalytics({ payload: values }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: settlementsAnalyticsUrl(modeType),
            params: { ...values },
            headers: {
                Authorization: `Bearer ${access_token}`
            }
        };

        const response = yield call(fetchJSON, options);

        yield put(getSettlementsAnalyticsSuccess(response.data));
    } catch (error) {
        const errorMessage = error?.data?.error?.message ? error.data?.error?.message : 'Something went wrong';
        toast.error(errorMessage);
    }
}

function* callDownloadSettlementCsv({ payload: values }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');
    try {
        const options = {
            method: 'GET',
            url: downloadSettlementCsvUrl(modeType),
            params: { ...values, tag: env.REACT_APP_SPAY_SETTLEMENT_TAG || 'MCH_settlement_admin' },
            headers: {
                Authorization: `Bearer ${access_token}`,
                'api-key': env.REACT_APP_SPAY_SETTLEMENT_CD
            }
        };

        const response = yield call(fetchJSON, options);

        const blob = new Blob([response.data], { type: 'text/csv' });
        const blobUrl = window.URL.createObjectURL(blob);
        const tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobUrl;
        tempLink.download = 'settlement.csv';
        tempLink.setAttribute('target', '_blank');
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobUrl);

        yield put(getSettlementsCsvSuccess('It successfully downloaded'));
        toast.success('CSV was downloaded successfully');
    } catch (error) {
        const errorMessage = error?.data?.error?.message ? error.data?.error?.message : 'Something went wrong';
        toast.error(errorMessage);
    }
}

export function* watchCallGetSinglePayouts() {
    yield takeEvery(GET_SINGLE_PAYOUTS, callGetSinglePayouts);
}
export function* watchCallGetAllPayouts() {
    yield takeEvery(GET_ALL_PAYOUTS, callGetAllPayouts);
}

export function* watchCallGetTransactionForSettlement() {
    yield takeEvery(GET_SETTLEMENT_TRANSACTION, callGetTransactionForSettlement);
}

export function* watchCallGetUnsettledPayout() {
    yield takeEvery(GET_UNSETTLED_SETTLEMENTS, callGetUnsettledPayout);
}

export function* watchCallGetSettlementAnalytics() {
    yield takeEvery(GET_SETLLEMENTS_ANALYTICS, callGetSettlementAnalytics);
}

export function* watchCallDownloadSettlementCsv() {
    yield takeEvery(DOWNLOAD_SETTLEMENT_CSV, callDownloadSettlementCsv)
}

function* PayoutsSaga() {
    yield all([
        fork(watchCallGetAllPayouts),
        fork(watchCallGetSinglePayouts),
        fork(watchCallGetTransactionForSettlement),
        fork(watchCallGetUnsettledPayout),
        fork(watchCallGetSettlementAnalytics),
        fork(watchCallDownloadSettlementCsv)
    ]);
}
export default PayoutsSaga;
